import React, { useState, useEffect, useRef } from 'react';
import {
    formatMoneda, formatoMonto, validaMonto
} from '../../util/varios';
import { Mensaje } from '../mensajes';


import axios from 'axios';
import useTableFijo from '../useTableFijo';

import { AgregarCuentasIngresos } from './modalAgregarCuentasIngresos';
import { Dimmer } from '../spinner';


function TablaDetalleCuenta(props) {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');


    const headCells = [
        { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Part.', textAlign: 'center' },
        { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Gen.', textAlign: 'center' },
        { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Esp.', textAlign: 'center' },
        { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Sub.', textAlign: 'center' },
        { id: '5', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Concepto', textAlign: 'center' },
        { id: '6', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Disponible', textAlign: 'center' },
        { id: '7', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Monto Credito Adicional', textAlign: 'center' },
        { id: '8', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Opciones', textAlign: 'center' },
    ]

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const txtMonto = useRef([]);
    const txtMontoTotal = useRef();



    const blanquearCampos = () => {
        setMostrar(false);
        setTitulo('');
        setMsg('');
    }

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 220);


    const handleCloseMensa = () => {
        setMostrar(false);
        blanquearCampos()
    }


    const cerrarModalActualizar = () => {

        setMostrar5(false);
    }


    const opciones = (ope, index) => (event) => {

        event.preventDefault();
        blanquearCampos();

        if (ope === 1) {

            setMostrar5(true);
            setOperacion(1);
            blanquearCampos()

        } if (ope === 3) {

        }

    }

    const handleAceptarDatos = (datos) => {
        setMostrar5(false);

        let data = [...records];

        for (let i = 0; i < datos.length; i++) {

            data.push({
                uno: datos[i].uno,
                dos: datos[i].dos,
                tres: datos[i].tres,
                cuatro: datos[i].cuatro,
                /*cinco: datos[i].cinco,
                seis: datos[i].seis,
                siete: datos[i].siete,
                ocho: datos[i].ocho,
                nueve: datos[i].nueve,
                auxiliar: datos[i].auxiliar,*/
                descripcion: datos[i].descripcion,
                montoinicial: datos[i].montoinicial,
                disponible: datos[i].disponible,
                monto: datos[i].monto,
                idcuenta: datos[i].idcuenta,
                cuenta: datos[i].cuenta,
                idcat: datos[i].idcat,
                idpuc: datos[i].idpuc,
                descripcionaux: datos[i].descripcionaux,
                descripcat: '',
                descrippuc: '',
                idmovimiento: '0',

            });

        }
        let total = 0.00;
        for (let e = 0; e < data.length; e++) {
            total = parseFloat(total) + parseFloat(data[e].monto);
        }

        //montoiva = total * iva / 100;

        txtMontoTotal.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        setRecords(data);
        props.data(data);
    }


    useEffect(() => {
        txtMontoTotal.current.value = '0,00';

        if (props.datarecords && props.datarecords.length > 0 && props.datarecords[0].montocue > 0.00) {

            var data = [...props.datarecords];
            var datos = [];

            for (let i = 0; i < data.length; i++) {

                datos.push({

                    uno: data[i].cuenta.substring(0, 3),
                    dos: data[i].cuenta.substring(3, 5),
                    tres: data[i].cuenta.substring(5, 7),
                    cuatro: data[i].cuenta.substring(7, 9),
                    /*cinco: data[i].cuenta.substring(8, 10),
                    seis: data[i].cuenta.substring(10, 13),
                    siete: data[i].cuenta.substring(13, 15),
                    ocho: data[i].cuenta.substring(15, 17),
                    nueve: data[i].cuenta.substring(17, 19),
                    auxiliar: data[i].auxiliar,*/
                    descripcat: '',
                    descrippuc: '',
                    monto: data[i].montocue,
                    montoinicial: data[i].montoinicial,
                    disponible: data[i].montodispo,
                    descripcion: data[i].descripcion,
                    idcat: data[i].idcategoria,
                    idpuc: data[i].idpuc,
                    idcuenta: data[i].idcuenta,
                    cuenta: data[i].cuenta,
                    idmovimiento: data[i].iddetalle,

                });

            }

            let total = 0.00;

            for (let e = 0; e < data.length; e++) {
                total = parseFloat(total) + parseFloat(data[e].montocue);
            }

            txtMontoTotal.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            setRecords(datos);
            props.data(datos);
        } else {
            setRecords([]);
        }

    }, [props.datarecords]);

    const eliminarCuenta = (item) => (e) => {
        e.preventDefault();

        var datos = [...records];
        var elementos = [];

        for (let i = 0; i < datos.length; i++) {

            if (item.cuenta !== datos[i].cuenta) {
                elementos.push(datos[i]);
            }

        }

        let total = 0.00;
        for (let e = 0; e < elementos.length; e++) {
            total = parseFloat(total) + parseFloat(elementos[e].monto);
        }

        txtMontoTotal.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);

        setRecords(elementos);
        props.data(elementos);

    }

    return (
        <div>

            <AgregarCuentasIngresos
                show={mostrar5}
                operacion={operacion}
                onDatos={handleAceptarDatos}
                onHideCancela={cerrarModalActualizar}
                cuentas={records}
            />
            <Mensaje titulo={titulo} mensaje={msg}
                show={mostrar}
                onHide={handleCloseMensa} />

            <Dimmer active={activate} inverted>

            </Dimmer>



            <div className="row col-md-12 mx-auto m-0">

                <div className="col-md-11 m-0 px-0 mb-1">
                    <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }}>
                        <TblHead />

                        <tbody>
                            {

                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item + item.idcuenta} className="table-bordered" style={{ padding: "0", height: '40px' }}>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: "10px" }}>{item.uno}</td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '10px' }}>{item.dos}</td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: "10px" }}>{item.tres} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: "10px" }}>{item.cuatro} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "center", width: '150px' }}>{item.descripcion} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "right", width: '50px' }}>{formatMoneda(item.disponible.toString().replace(',', '').replace('.', ','), ',', '.', 2)} </td>
                                        <td className='align-middle' style={{ fontSize: "10px", textAlign: "right", width: '50px' }}>{formatMoneda(item.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2)} </td>
                                        <td ssName='align-middle' style={{ fontSize: "10px", textAlign: "center", width: "60px" }}>
                                            <button onClick={eliminarCuenta(item)} disabled={props.operacion === 4 || props.operacion === 3 ? true : false} className="btn btn-danger btn-sm rounded-circle"><i className="fa fa-trash-alt"></i></button>
                                        </td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    {/* <TblPagination /> */}

                </div>
                <div className='col-md-1 m-auto mb-1'>

                    <div className="col-md-12">
                        <button onClick={opciones(1, '')} disabled={props.operacion === 4 || props.operacion === 3 ? true : false} className="btn btn-primary btn-sm rounded-pill"><i className="fas fa-plus"><small> INCLUIR</small></i> </button>
                    </div>

                </div>

                <div className='col-md-11 m-0 px-0  mb-1'>
                    <div className='col-sm-3 ml-auto px-0'>
                        <div className="input-group input-group-sm m-0 w-100">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Total Credito Adicional:</label>
                            <input type="text" autoComplete='off' className="form-control text-right bg-transparent" disabled={true} ref={txtMontoTotal} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="monto" />
                        </div>
                    </div>
                </div>
            </div>


        </div>

    );

}

export default TablaDetalleCuenta;
